import styles from './userLine.module.scss';
import { Select } from 'antd';
import { useState, useRef, useEffect } from 'react';
import * as echarts from 'echarts';
import { period } from '@/apis/statistics'

const UserLine = () => {

	const [type, setType] = useState(0);
	const chartRef = useRef(null);
	const [xAxisData, setXAxisData] = useState([]);
	const [viewData, setViewData] = useState([]);//浏览量
	const [visitsData, setVisitsData] = useState([]);//访客数
	const [registerData, setRegisterData] = useState([]);//注册数
	const handleChange = (value) => {
		setType(value)
	}

	const getList = () => {
		period({
			type: type
		}).then(res => {
			const list = res.data?.visitsStatistics.reverse() || []
			let xData = [], y2 = [], y3 = []
			let y1 = list.map(item => {
				if (type === 0) {
					xData.push(item.time.substring(11, 13) + "时")
				} else if (type === 1) {
					xData.push(item.time.substring(8, 10) + "日")
				} else if (type === 2) {
					xData.push(item.time.substring(5, 7) + "月")
				}
				y2.push(item.visits)
				y3.push(item.register)
				return item.view
			})
			setXAxisData(xData)
			setViewData(y1)
			setVisitsData(y2)
			setRegisterData(y3)
		})

	}
	useEffect(() => {
		getList()
	}, [type])

	useEffect(() => {
		const chartDom = chartRef.current;
		const myChart = echarts.init(chartDom);
		const option = {
			grid: {
				left: '3%',
				right: '4%',
				bottom: '40px',
				top: "45px",
				containLabel: true
			},
			tooltip: {
				trigger: 'axis',
			},
			legend: {},
			xAxis: {
				type: 'category',
				data: xAxisData,
			},
			yAxis: {
				name: "数量(个)",
				type: 'value',
				splitLine: {
					lineStyle: {
						type: 'dashed'
					}
				},
			},
			dataZoom: [
				{
					type: 'slider',
					show: true,
					height: '18px',
					bottom: '10px',
					left: '70px',
					right: '50px',
					borderColor: '#8FDFFE',
					backgroundColor: '#8fdffe99',
					handleIcon: 'M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z',
					handleColor: '#8FDFFE',
					handleSize: 20,
					handleStyle: {
						borderColor: '#8FDFFE',
						shadowBlur: 4,
						shadowOffsetX: 1,
						shadowOffsetY: 1,
						shadowColor: '#e5e5e5'
					},
					start: 0,
					end: 100
				}
			],
			series: [
				{
					name: '浏览量',
					type: 'line',
					data: viewData,
				}, {
					name: '访客数',
					type: 'line',
					data: visitsData,
				}, {
					name: '注册数',
					type: 'line',
					data: registerData,
				},
			],
		};
		myChart.setOption(option);
		window.addEventListener('resize', () => {
			myChart && myChart.resize();
		});
		return () => {
			myChart.dispose();
		};
	}, [xAxisData,viewData,visitsData,registerData]);


	return <div className={styles.userLineBox}>
		<Select
			defaultValue={type}
			style={{ width: 120 }}
			size="small"
			onChange={handleChange}
			options={[
				{ value: 0, label: '近24小时' },
				{ value: 1, label: '近30天' },
				{ value: 2, label: '近12个月' },
			]}
		/>
		<div ref={chartRef} className={styles.echartBox}>曲线图</div>
	</div>
}
export default UserLine;